import { global } from './global.js'

export let helpers = {
    b64toBlob(b64Data, contentType, sliceSize) {
        contentType = contentType || '';
        sliceSize = sliceSize || 512;

        let byteCharacters = atob(b64Data);
        let byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            let slice = byteCharacters.slice(offset, offset + sliceSize);

            let byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            let byteArray = new Uint8Array(byteNumbers);

            byteArrays.push(byteArray);
        }

        let blob = new Blob(byteArrays, {type: contentType});
        return blob;
    },
    getImageData(b64Data) {
        let block = b64Data.split(";");
        return {
            b64Data: block[1].split(",")[1],
            contentType: block[0].split(":")[1]
        }
    },
    initializeDatabase() {

        window.database = openDatabase(
            "sqlite_appreview",
            "1.0",
            "Ag Printers Preview",
            50 * 1024 * 1024
        );

        window.database.transaction(
			function(transaction) {

				transaction.executeSql(
					"CREATE TABLE IF NOT EXISTS files (" +
						"fileName TEXT NOT NULL PRIMARY KEY," +
						"content TEXT NOT NULL" +
					");"
                    //"DROP TABLE files"
				);

			},
            function(error) {
			    console.log(error);
            }
		);
    },
    createFile(fileName, content, callback) {
        window.database.transaction(
            (transaction) => {
                transaction.executeSql(
                    (
                        "INSERT INTO files (fileName, content) VALUES (?, ?);"
                    ),
                    [
                        fileName, content
                    ],
                    (transaction, results) => {
                        callback(content);
                    }
                );

            },
            (error) => {
                if(error.code === 1 || error.code === 6) {
                    this.updateFile(fileName, content, callback);
                }
            }
        );
    },
    updateFile(fileName, content, callback) {

        window.database.transaction(
            (transaction) => {
                transaction.executeSql(
                        (
                            "UPDATE files set content=? where fileName=?"
                        ),
                        [
                            content, fileName
                        ],
                        (transaction, results) => {
                            callback(content);
                        }
                    );

            },
            (error) => {
                console.log(error);
            }
        );
    },
    readFile(fileName, callback) {
        return window.database.transaction(
            (transaction) => {

                transaction.executeSql(
                    (
                        "SELECT * FROM files WHERE fileName = ?"
                    ),
                    [fileName],
                    (transaction, results) => {
                        if(results.rows.length > 0) {
                            callback(results.rows.item(0).content);
                        } else {
                            callback(false);
                        }
                    }
                );

            },
            (error) => {
                console.log(error);
            }
        );
    },
    sortObjectArray(array, property) {
        let compare = (a, b) => {
            if (a[property] < b[property])
                return -1;
            if (a[property] > b[property])
                return 1;
            return 0;
        };

        return array.sort(compare);
    }
};



// WEBPACK FOOTER //
// ./src/helpers.js